import axios, { AxiosResponse } from "axios";
import { configService, ObjectFromEnvelope } from "./config.service";
import { WebAcceptPages } from "../models/webacceptpages-model";
import { convertDateOnlyToUtc } from "../utils/dateUtils";
import { Changerequest } from "../models/changerequest-model";
import { parse } from "date-fns";
import store from "@/store";
import { User } from "@/modules/security/models/user-model";
class ApproveWorkHoursService {
  async fetchApproveWorkHours(
    fromDate: Date,
    toDate: Date,
    employee_id: number | undefined = undefined
  ): Promise<WebAcceptPages> {
    const user: User = store.getters["security/getUser"]();
    let params: any = {
      institution_id: configService.institutionId(),
      start_date: convertDateOnlyToUtc(fromDate),
      end_date: convertDateOnlyToUtc(toDate)
    };
    if (user.isEmployee() || employee_id) {
      params = {
        employee_id: employee_id ? employee_id : user.employee_id,
        start_date: convertDateOnlyToUtc(fromDate),
        end_date: convertDateOnlyToUtc(toDate)
      };
    }
    const response: AxiosResponse = await axios.get<any>(
      configService.personaleOrAdminUrl("web_accept_pages.json"),
      {
        params: params
      }
    );
    return WebAcceptPages.fromJSON(ObjectFromEnvelope<WebAcceptPages>(response.data));
  }

  async fetchUntreatedChangeRequests(
    fromDate: Date,
    toDate: Date,
    employeeId: number
  ): Promise<any[]> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("change_requests.json?untreated=true"),
      {
        params: {
          start_date: convertDateOnlyToUtc(fromDate),
          end_date: convertDateOnlyToUtc(toDate),
          employee_id: employeeId
        }
      }
    );
    return (response.data as any).data;
  }

  async getMinMaxUntreatedDates(): Promise<{ minDate: Date; maxDate: Date }> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("change_requests/min_max_untreated_dates.json")
    );
    return {
      minDate: parse(response.data.data.min_date, "yyyy-MM-dd", new Date()),
      maxDate: parse(response.data.data.max_date, "yyyy-MM-dd", new Date())
    };
  }

  async acceptWorkHours(
    acceptIds: number[] | undefined,
    resetIds: number[] | undefined,
    rejectIds: number[] | undefined
  ): Promise<number[]> {
    return new Promise((resolve, reject) => {
      if (
        (acceptIds?.length || 0) > 0 ||
        (resetIds?.length || 0) > 0 ||
        (rejectIds?.length || 0) > 0
      ) {
        axios
          .post(configService.APIInstitutionUrl("change_requests/accept.json"), {
            accept_ids: acceptIds?.join(","),
            reset_ids: resetIds?.join(","),
            reject_ids: rejectIds?.join(",")
          })
          .then(() => {
            resolve([...(acceptIds || []), ...(resetIds || []), ...(rejectIds || [])]);
          })
          .catch((error) => reject(error));
      } else {
        resolve([]);
      }
    });
  }

  async createChangeRequest(changerequest: Changerequest): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(configService.personaleOrAdminUrl("change_requests.json"), {
          supervision_time_duty_change_request: {
            duty_id: changerequest.duty_id,
            start_time: changerequest.start_time,
            end_time: changerequest.end_time,
            employee_id: changerequest.employee_id,
            date: convertDateOnlyToUtc(changerequest.date),
            purpose_is_for_deletion_of_duty: changerequest.purpose_is_for_deletion_of_duty,
            comment: changerequest.comment.trim()
          }
        })
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }

  async updateChangeRequest(changerequest: Changerequest): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .put(configService.personaleOrAdminUrl("change_requests/" + changerequest.id + ".json"), {
          supervision_time_duty_change_request: {
            duty_id: changerequest.duty_id,
            start_time: changerequest.start_time,
            end_time: changerequest.end_time,
            id: changerequest.id,
            comment: changerequest.comment.trim(),
            purpose_is_for_deletion_of_duty: changerequest.purpose_is_for_deletion_of_duty
          }
        })
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }
  async deleteChangeRequest(changerequestId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .delete(configService.personaleOrAdminUrl("change_requests/" + changerequestId + ".json"))
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    });
  }

  async updateChangeRequestComment(changerequestId: number, comment: string): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .put(configService.personaleOrAdminUrl(`change_requests/${changerequestId}/comment.json`), {
          comment: comment
        })
        .then(() => {
          resolve();
        })
        .catch((error) => reject(error));
    })
  }
}

export const approveWorkHoursService: ApproveWorkHoursService = new ApproveWorkHoursService();
